import { createContext, useContext } from 'react'
import type { BranchOption } from './branchApi'

export interface ActiveBranchesValue {
  options: readonly BranchOption[]
  /** Bo'sh — foydalanuvchiga ruxsat etilgan hamma filial */
  selected: readonly string[]
  setSelected: (ids: readonly string[]) => void
}

export const ActiveBranchesContext = createContext<ActiveBranchesValue>({
  options: [],
  selected: [],
  setSelected: () => {},
})

export function useActiveBranches(): ActiveBranchesValue {
  return useContext(ActiveBranchesContext)
}
